import {useSelector} from "react-redux";

export default function (params) {
    const searchSummary = useSelector(state => state.search.searchSummary);
    const loadingSummary = useSelector(state => state.search.loadingSummary);
    const searchSummaryError = useSelector(state => state.search.searchSummaryError);
    return { searchSummary, loadingSummary, searchSummaryError };
}
